import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import { Event, decode } from 'utils/Helper';
import socket from "utils/Socket";
import storage from "utils/Storage";
import C from "utils/Constant";
import Details from "../../components/User/Stat/Details";
import TipUser from "../../components/User/Tip";

class UserModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
      detail: true,
      tip: false,
      notFound: false,
      data: [],
      modal_name: "User Information",
      coin: this.props.coin
        ? this.props.coin
        : storage.getKey("coin") !== null
        ? storage.getKey("coin")
        : "SOL",
    };
  }

  componentWillReceiveProps(nextProps, nextContext) {
    if (nextProps.modal) {
      this.setState({ show: false });
    }
  }

  componentDidMount() {
    socket.on(C.USER_INFO, (data) => this.getUserInfo(decode(data)));

    Event.on("force_modal_user", () => {
      this.setState({ show: true, effect: "zoomIn", haveData: "no", data: [] });
    });

    Event.on("force_modal_tip", () => {
      this.setState({ tip: true, detail: false, modal_name: "Tip User" });
    });

    Event.on("force_modal_tip_close", () => {
      this.setState({ tip: false, detail: true, modal_name: "User Information" });
    });

    Event.on("single_game_modal_by_chart", () => {
      this.setState({ modal_name: "Game Details" });
    });

    Event.on("back_from_chart", () => {
      this.setState({ modal_name: "User Information" });
    });

    Event.on("close_user_modal", () => {
      this.handleClose();
    });
  }

  handleClose = () => {
    this.setState({
      detail: true,
      tip: false,
      notFound: false,
      show: false,
      effect: "zoomOut",
    });
  };

  getUserInfo = (data) => {
    if (data.status) {
      console.log("datttttt", data);
      this.setState({ haveData: "ok", data: data });
    } else {
      this.setState({ notFound: true });
    }
  };

  render() {
    let { chart_coin, t } = this.props;
    chart_coin = chart_coin ? chart_coin : this.state.coin;
    return (
      <Modal
        size="lg"
        backdrop={"static"}
        centered={true}
        show={this.state.show}
        onHide={this.handleClose}
        aria-labelledby="user-modal"
      >
        <Modal.Header className="modal-header px-4">
          {this.state.modal_name}
          <button type="button" className="close p-2" onClick={this.handleClose}>
            <i className={"mdi mdi-close"} />
          </button>
        </Modal.Header>
        <Modal.Body className={"user-modal-bg p-1"}>
          {this.state.notFound ? (
            <>
              <div className="text-center text-yellow" style={{ minHeight: 370 }}>
                {/* User Not Found */}[ STATS IS HIDDEN ]
              </div>
            </>
          ) : (
            <>
              {this.state.detail ? (
                <>
                  <div
                    className={
                      this.state.tip === true
                        ? "container-fluid mduser animated fadeOut"
                        : "container-fluid mduser"
                    }
                  >
                    <Details
                      t={this.props.t}
                      haveData={this.state.haveData}
                      name={this.state.data.name}
                      id={this.state.data.id}
                      coin={this.state.coin}
                      data={this.state.data}
                    />
                  </div>
                </>
              ) : (
                <>
                  {this.state.tip === true && (
                    <div className={"container-fluid animated fadeIn"}>
                      <TipUser id={this.state.data.id} name={this.state.data.name} />
                    </div>
                  )}
                </>
              )}
            </>
          )}
        </Modal.Body>
      </Modal>
    );
  }
}

export default UserModal;
